<div class="edit-container">
	<h1 class="edit-title">Editare Fișiere</h1>
	<form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <h3>Fișiere existente</h3>
        <div class="mb-5">
            <div class="solicitare-card__upload-files" *ngIf="form.value.existingFiles.length > 0 ">
                <div class="solicitare-card__upload-file" *ngFor="let uploadedFile of form.value.existingFiles; let i = index">
                    <span class="solicitare-card__upload-file-name">
                        {{ (uploadedFile.orig_name.length > 30) ? (uploadedFile.orig_name | slice: 0:30) + '..' : (uploadedFile.orig_name)
                        }}
                    </span>
                    <div *ngIf="form.value.existingFiles.length > 1">
                        <button class="solicitare-card__upload-file-delete" type="button" matTooltip="Șterge fișierul existent" (click)="removeExistingFile(i)">
                            <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="form.value.existingFiles.length == 0" class="d-flex justify-content-center">
                <h2><strong class="p-0 m-0">Nu există fișiere încărcate</strong></h2>
            </div>
        </div>

        <h3>Adaugă fișiere noi</h3>
        <div class="solicitare-card__upload mb-5">
            <div class="solicitare-card__upload-header">
                <p class="upload-text">Fotografii/Documente</p>
                <button class="upload-btn" (click)="fileInput.click()" type="button">
                    <mat-icon class="upload-icon me-2">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="solicitare-card__upload-files" *ngIf="form.value.files.length > 0 && !uploading.file">
                <div class="solicitare-card__upload-file" *ngFor="let uploadedFile of form.value.files; let i = index">
                    <span class="solicitare-card__upload-file-name">
                        {{ (uploadedFile.original_name.length > 30) ? (uploadedFile.original_name | slice: 0:30) + '..' : (uploadedFile.original_name)
                        }}
                    </span>
                    <div>
                        <button class="solicitare-card__upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                            <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading.file"></mat-spinner>

            <input type="file" accept="image/png, image/jpeg, image/jpg, application/pdf" id="upload-file-input-0" #fileInput
                name="fileInput" (change)="addFile($event, 'file')" multiple style="display: none">
        </div>
		<div class="row">
			<div class="col d-flex justify-content-between">
				<button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
					{{ helper.dialogConfig.buttonLabels.close }}
				</button>
				<button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
					{{ helper.dialogConfig.buttonLabels.save }}
				</button>
			</div>
		</div>
	</form>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
		</div>
	</div>
</div>